module.exports = "/_next/static/videos/final-65adac90538bd54c0edee3d05d667b75.mp4";